export default __webpack_public_path__ + "static/media/sticker-on.3ec0e73b.png";